import { render } from "./VehicleDashboardView.vue?vue&type=template&id=785c629e&scoped=true"
import script from "./VehicleDashboardView.vue?vue&type=script&lang=js"
export * from "./VehicleDashboardView.vue?vue&type=script&lang=js"

import "./VehicleDashboardView.vue?vue&type=style&index=0&id=785c629e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-785c629e"]])

export default __exports__